import styled from "styled-components";
import { RAButtonPrimary, RAImage, RATypography } from "@/components/customs";
import { Col, Row, Grid } from "antd";
const { useBreakpoint } = Grid;

export function ComponentPageServerErrors({ statusCode }) {
	const screens = useBreakpoint();
	const getHeightOfBanner = () => {
		let height = "400px";
		if (screens.md) {
			height = "400px";
		} else if (screens.sm) {
			height = "270px";
		} else if (screens.xs) {
			height = "210px";
		}
		return height;
	};
	return (
		<HomepageContainer>
			<Body>
				<Row style={{ width: "100%" }} justify="center">
					<Col span={12}>
						<RAImage width="100%" height={getHeightOfBanner()} url="/images/500.png" />
					</Col>
				</Row>
				<Row style={{ width: "100%" }} justify="center">
					<Col span={24}>
						<RATypography align="center" variant="sub-heading1" color="#222222">
							Internal Server Error
						</RATypography>
					</Col>
					<Col xl={8} lg={12} md={16} sm={20} xs={24} style={{ padding: "0 20px" }}>
						<RATypography align="center" variant="body3" top={12} color="#595959">
							Uh oh, it looks like we have encountered some turbulence! Please excuse us while we work to
							find some smoother air.
						</RATypography>
					</Col>
					<Col
						span={24}
						style={{
							marginTop: "30px",
							display: "flex",
							justifyContent: "center",
						}}
					>
						<RAButtonPrimary type="link" title="BACK TO HOME PAGE" href="/" />
					</Col>
				</Row>
			</Body>
		</HomepageContainer>
	);
}

const HomepageContainer = styled.div`
	width: 100%;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
`;
const Body = styled.div`
	min-height: 100vh;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;
